import React from "react";
import "../style/arboriculture.css";
import gardenImage from "../parm_assets/parm_ca.jpeg"; // replace with your actual image path
import infoIcon from "../parm_assets/tree_icons.png";

const ArboricultureSection = () => {
  return (
    <section className="arboriculture-section">
      {/* Milestone Section */}
      <div className="milestone-section">
        <div className="milestone-content">
          <p className="milestone-tag">
            <img src={infoIcon} alt="icon" className="tree-icon" />
            PArM’s Milestone</p>
          <h2>A decade of growth, expertise and trust in arboriculture.</h2>
          <p className="milestone-desc">
            Continuing a decade of excellence, advancing expertise and
            strengthening a trusted arboriculture network.
          </p>

          <div className="milestone-stats">
            <div className="stat-card">
              <h3>140+</h3>
              <p>Certified Arborist</p>
            </div>
            <div className="stat-card">
              <h3>455+</h3>
              <p>PArM Members</p>
            </div>
            <div className="stat-card">
              <h3>30k+</h3>
              <p>Certified Arborist Worlwide</p>
            </div>
            <div className="stat-card">
              <h3>21+</h3>
              <p>Years of Establishment</p>
            </div>
          </div>
        </div>
      </div>

      {/* Find Member Section */}
      <div className="find-member-section">
        <div className="find-member-content">
          <div className="find-member-left">
            <img src={gardenImage} alt="Arboriculture" className="garden-img" />
          </div>
          <div className="find-member-right">
            <p className="find-tag">Find Our Member</p>
            <h2>Know Your Certified Arborist and Members</h2>

            <div className="find-cards">
              <div className="find-card">
                <h4>Find an Arborist</h4>
                <p>Look for national and international Arborist here.</p>
                <a
                    href="https://www.treesaregood.org/findanarborist/findanarborist"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="find-btn"
                > 
                    Find Arborist →
                </a>
                {/* <button className="find-btn">Find Arborist →</button> */}
              </div>
              <div className="find-card">
                <h4>Find a PArM Member</h4>
                <p>
                  Look for member of Malaysia Society of Arborist.
                </p>
                <button className="find-btn">Find PArM Member →</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ArboricultureSection;
